import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';
/* IMPORT HERE */
export const attachments: ThemeUICSSObject = {
  /* PREPEND HERE */
  alignItems: 'center',
  display: 'flex',
  flexDirection: responsive({ 0: 'column', 3: 'row' }),
  flexWrap: 'wrap',
  gap: spacing(3),

  '.attachments__more_button': {
    border: '1px solid',
    borderColor: 'palette.border.article',
    borderRadius: 'elementBox',
    boxShadow: 'sharp',
    p: 2,
  },

  '.file_box': {
    alignItems: 'center',
    border: '1px solid',
    borderColor: 'palette.border.article',
    borderRadius: 'elementBox',
    boxShadow: 'sharp',
    display: 'flex',
    gap: spacing(3),
    width: responsive({
      0: '100%',
      3: 'min(90vw, 200px)',
    }),
    p: 2,
  },

  '.file_box__icon': {
    flexShrink: 0,
  },

  '.file_box__name': {
    boxSizing: 'border-box',
    flexGrow: 1,
    margin: '0px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  '.file_box__remove': {
    flexShrink: 0,
    p: 4,
  },
};
